import client from './apiClient'
import utility from './utility'
import sessionCookie from './sessionCookie'
import culturalItemClient from './culturalItemClient'
import jarvisUrlParams from './jarvisUrlParams'
import 'regenerator-runtime/runtime'

async function getImagesData(uuidsList) {
  const metadataForGAnalytics = []
  const sanitizedUuids = jarvisUrlParams.sanitizeUuids(Array.isArray(uuidsList) ? uuidsList : [uuidsList])

  if (!sanitizedUuids.length) {
    return []
  }

  const allMetadataRequests = sanitizedUuids.map(currentUuid => {
    return client.getMetaData(process.env.API_IMAGE_METADATA_SEARCH_ENDPOINT, currentUuid).then(response => {
      metadataForGAnalytics.push(response)
      const maxZoomLevelPercentage = utility.getSafe(() => response.maxZoomLevelPercentage, 75)
      const ppi = utility.getSafe(() => response.ppi, null)
      const tileSources = [process.env.API_DZI_BACKEND_BASE_URL + currentUuid + process.env.DZI_FILENAME]

      return {
        maxZoomLevelPercentage: maxZoomLevelPercentage,
        ppi: ppi,
        tileSources: tileSources,
        metadataForGAnalytics: metadataForGAnalytics,
        title: response.title,
        uuid: response.uuid,
        acquisitionType: response.acquisitionType,
        acquisitionDate: response.acquisitionDate,
        canRotate: response.canRotate
      }
    })
  })

  const retrievedImages = await Promise.all(allMetadataRequests)
  await sessionCookie.create()
  return retrievedImages
}

function getCulturalItemData(culturalItemUuid, imageToShowUuid) {
  const metadataForGAnalytics = []
  return culturalItemClient.getculturalItemTitleAndImagesUuidsAndThumbLinks(culturalItemUuid).then(result => {
    if (!result.imagesUuids.length) {
      return [
        {
          tileSources: [],
          thumbLinks: [],
          metadataForGAnalytics: '',
          title: ''
        }
      ]
    }

    let imageToShow = null
    if (imageToShowUuid && result.imagesUuids.includes(imageToShowUuid)) imageToShow = imageToShowUuid
    else imageToShow = result.imagesUuids[0]

    return client.getMetaData(process.env.API_IMAGE_METADATA_SEARCH_ENDPOINT, imageToShow).then(async metadata => {
      metadataForGAnalytics.push(metadata)
      const maxZoomLevelPercentage = utility.getSafe(() => metadata.maxZoomLevelPercentage, 75)
      const ppi = utility.getSafe(() => metadata.ppi, null)
      const tileSources = result.imagesUuids.map(
        uuid => process.env.API_DZI_BACKEND_BASE_URL + uuid + process.env.DZI_FILENAME
      )
      await sessionCookie.create()
      return [
        {
          maxZoomLevelPercentage: maxZoomLevelPercentage,
          ppi: ppi,
          tileSources: tileSources,
          thumbLinks: result.thumbLinks,
          metadataForGAnalytics: metadataForGAnalytics,
          uuid: metadata.uuid,
          title: result.title
        }
      ]
    })
  })
}

export default { getImagesData, getCulturalItemData }
